import React, { Component } from 'react';
import * as _ from 'lodash';
import * as PropTypes from 'prop-types';
import { LabeledSelect } from '../../../../shared/labeled-select/LabeledSelect';
import { BlueContainedButton } from '../../../../shared/button/blue-contained-button/BlueContainedButton';

/* Makes a sandbox: a copy of the rules and the risk configuration of a production jurisdiction to play simulated players in. */
export class CreateWorkspaceModalContent extends Component {
    static propTypes = {
        // The production jurisdictions that can be copied: { code, name }
        sourceJurisdictions: PropTypes.array,
        createWorkspace: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = { sourceCode: null };
    }

    makeOptions = () =>
        _.map(this.props.sourceJurisdictions, jurisdiction => ({
            value: jurisdiction.code,
            label: `${jurisdiction.name} (${jurisdiction.code})`
        }));

    handleCreate = () => {
        const { createWorkspace } = this.props;

        _.isFunction(createWorkspace) &&
            createWorkspace({ sourceCode: this.state.sourceCode });
        this.setState({ sourceCode: null });
    };

    render() {
        const options = this.makeOptions();

        return (
            <div className={'simulation'}>
                <div className={'sim-form create-workspace-modal-content'}>
                    <div className={'sim-section-note'}>
                        A sandbox gets a copy of the rules and the risk
                        configuration of a jurisdiction. Simulated players and
                        their alerts stay in the sandbox and are never counted
                        in the jurisdiction it was copied from.
                    </div>
                    {options.length ? (
                        <LabeledSelect
                            className={'sim-field'}
                            label={'Copy the rules of'}
                            options={options}
                            value={this.state.sourceCode}
                            onChange={sourceCode =>
                                this.setState({ sourceCode })
                            }
                        />
                    ) : (
                        <div className={'sim-banner warning'}>
                            There is no jurisdiction to copy.
                        </div>
                    )}
                    <div className={'sim-actions-row'}>
                        <BlueContainedButton
                            text={'Create sandbox'}
                            disabled={!this.state.sourceCode}
                            onClick={this.handleCreate}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
